<template>
  <v-app-bar
    app
    :dark="theme === 'openvoxel'"
  >
    <router-link :to="{name: 'home'}">
      <img
        :src="logo"
        alt="logo"
        height="28"
      >
    </router-link>
    <v-spacer />
    <v-toolbar-items v-if="loggedIn">
      <v-menu offset-y>
        <template #activator="{ on }">
          <v-btn
            text
            v-on="on"
          >
            Your Scans
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item :to="{name: 'listScans'}">
            <v-list-item-title>Browse images</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{name: 'uploadScan'}">
            <v-list-item-title>Upload new images</v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item :to="{name: 'listShares'}">
            <v-list-item-title>Share your scans</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu offset-y>
        <template #activator="{ on }">
          <v-btn
            text
            v-on="on"
          >
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-list
          dense
          subheader
        >
          <v-subheader>Profile</v-subheader>
          <v-list-item :to="{name: 'forgotPassword'}">
            <v-list-item-title>View your profile</v-list-item-title>
          </v-list-item>
          <v-divider />

          <v-subheader>Account</v-subheader>
          <div v-if="theme !== 'openvoxel'">
            <v-list-item
              v-if="!isPremium"
              @click="$emit('showPlanDialog')"
            >
              <v-list-item-title>
                Plan
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              v-else
              @click="redirectToBilling"
            >
              <v-list-item-title>
                Billing
              </v-list-item-title>
            </v-list-item>
          </div>
          <v-list-item @click="$emit('showBottomDrawer')">
            <v-list-item-title>Privacy, Terms, Company &amp; More</v-list-item-title>
          </v-list-item>
          <v-divider />

          <v-list-item @click="logout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex';

import http from '@/http';
import NeuralikeLogo from '@/assets/Neuralike-Logo-Horizontal.svg';
import OpenvoxelLogo from '@/assets/Openvoxel-Logo.svg';

const theme = process.env.VUE_APP_THEME;

export default {
  name: 'BrainMenus',
  data() {
    return {
      theme,
      logo: theme === 'openvoxel' ? OpenvoxelLogo : NeuralikeLogo,
    };
  },
  computed: {
    ...mapGetters('auth', ['loggedIn']),
    ...mapGetters('profile', ['isPremium']),
  },
  methods: {
    async logout() {
      try {
        await this.$store.dispatch('auth/logout');
      } catch (e) {
        // noop
      }
      this.$router.push({ name: 'home' });
    },
    async redirectToBilling() {
      const resp = await http.request({
        url: '/stripe/portal/',
        method: 'post',
      });
      window.location.href = resp.data;
    },
  },
};
</script>
